import { Injectable } from '@angular/core';
import { ApiService, UserService } from '../..';

@Injectable()
export class TrangThaiKetNoiRfMeshService {

  constructor(private apiService: ApiService, private userService: UserService) { }
  APIURL = "api/ExcuteOracle";
  trangThaiKetNoiRfMesh(danhmucid, sotrang, sodong) {
    var param = {
      "config": '{"namesql":"PKG_TRANGTHAIKETNOIRFMESH.P_LAYDS_TKETRANGTHAI_RFMESH"}',
      "para": '{"v_danhmucid ":"' + danhmucid + '","v_sotrang":"' + sotrang + '","v_sodong":"' + sodong + '"}'
    };
    return this.apiService.Excute(this.APIURL, param);
  }
  getListCongToMatDuLieu(danhmucid, imei, sotrang, sodong) {
    var param = {
      "config": '{"namesql":"PKG_TRANGTHAIKETNOIRFMESH.P_LAYDS_CONGTO_MATDULIEU"}',
      "para": '{"v_danhmucid":"' + danhmucid + '","v_imei ":"' + imei + '","v_sotrang":"' + sotrang + '","v_sodong":"' + sodong + '"}'
    };
    return this.apiService.Excute(this.APIURL, param);
  }
  getListRepeaterOffline(danhmucid, imei, sotrang, sodong) {
    var param = {
      "config": '{"namesql":"PKG_TRANGTHAIKETNOIRFMESH.P_LAYDS_REPEATER_OFFLINE"}',
      "para": '{"v_danhmucid":"' + danhmucid + '","v_imei ":"' + imei + '","v_sotrang":"' + sotrang + '","v_sodong":"' + sodong + '"}'
    };
    return this.apiService.Excute(this.APIURL, param);
  }

  exportExcelChiTietCongToRepeater(data,danhmucid, imei, lacongto, tendiemdo, tenchucnang, noidungbaocao) {
    let cols = [];
    if (lacongto == 1) {
      cols = [
        { "name": "stt", "label": "STT", "horizontalalignment": "center" },
        { "name": "socongto", "label": "Số công tơ", "horizontalalignment": "left" },
        { "name": "macot", "label": "Mã cột", "horizontalalignment": "left" },
        { "name": "madiemdo", "label": "Mã điểm đo", "horizontalalignment": "left" },
        { "name": "tenkhachhang", "label": "Tên khách hàng", "horizontalalignment": "left" },
        { "name": "songay_kodl", "label": "Số ngày không có dữ liệu liên tục", "horizontalalignment": "center" },
        { "name": "ds_ngay_kodl", "label": "Ngày không có dữ liệu", "horizontalalignment": "center" },
      ];
    }
    else {
      cols = [
        { "name": "stt", "label": "STT", "horizontalalignment": "center" },
        { "name": "serial", "label": "Serial", "horizontalalignment": "left" },
        { "name": "type", "label": "Type", "horizontalalignment": "left" },
        { "name": "rfid", "label": "RFID", "horizontalalignment": "left" },
        { "name": "macot", "label": "Mã cột", "horizontalalignment": "left" },
        { "name": "songay_off", "label": "Số ngày offline liên tục", "horizontalalignment": "center" },
        { "name": "ds_ngay_off", "label": "Ngày offline", "horizontalalignment": "center" },
      ];
    }
    let curUs = this.userService.getCurrentUser();
    let para: any = JSON.stringify({
      v_danhmucid: danhmucid,
      v_imei: imei,
      v_sotrang: 0,
      v_sodong: 1000000,
    });
    let config: any;
    if (lacongto === 1) {
      config = JSON.stringify({ namesql: "PKG_TRANGTHAIKETNOIRFMESH.P_LAYDS_CONGTO_MATDULIEU" });
    }
    else {
      config = JSON.stringify({ namesql: "PKG_TRANGTHAIKETNOIRFMESH.P_LAYDS_REPEATER_OFFLINE" });
    }
    return this.apiService.exportExcel(data, cols, para, config, tendiemdo, tenchucnang, noidungbaocao);
  }

  saveExcel(data,danhmucid, imei, lacongto, tendiemdo, tenchucnang, noidungbaocao) {
    let cols = [];
    if (lacongto == 1) {
      cols = [
        { "name": "stt", "label": "STT", "horizontalalignment": "center" },
        { "name": "socongto", "label": "Số công tơ", "horizontalalignment": "left" },
        { "name": "macot", "label": "Mã cột", "horizontalalignment": "left" },
        { "name": "madiemdo", "label": "Mã điểm đo", "horizontalalignment": "left" },
        { "name": "tenkhachhang", "label": "Tên khách hàng", "horizontalalignment": "left" },
        { "name": "songay_kodl", "label": "Số ngày không có dữ liệu liên tục", "horizontalalignment": "center" },
        { "name": "ds_ngay_kodl", "label": "Ngày không có dữ liệu", "horizontalalignment": "center" },
      ];
    }
    else {
      cols = [
        { "name": "stt", "label": "STT", "horizontalalignment": "center" },
        { "name": "serial", "label": "Serial", "horizontalalignment": "left" },
        { "name": "type", "label": "Type", "horizontalalignment": "left" },
        { "name": "rfid", "label": "RFID", "horizontalalignment": "left" },
        { "name": "macot", "label": "Mã cột", "horizontalalignment": "left" },
        { "name": "songay_off", "label": "Số ngày offline liên tục", "horizontalalignment": "center" },
        { "name": "ds_ngay_off", "label": "Ngày offline", "horizontalalignment": "center" },
      ];
    }
    let curUs = this.userService.getCurrentUser();
    let para: any = JSON.stringify({
      v_danhmucid: danhmucid,
      v_imei: imei,
      v_sotrang: 0,
      v_sodong: 1000000,
    });
    let config: any;
    if (lacongto === 1) {
      config = JSON.stringify({ namesql: "PKG_TRANGTHAIKETNOIRFMESH.P_LAYDS_CONGTO_MATDULIEU" });
    }
    else {
      config = JSON.stringify({ namesql: "PKG_TRANGTHAIKETNOIRFMESH.P_LAYDS_REPEATER_OFFLINE" });
    }
    let dateNow = new Date();
    let strDate = dateNow.getDate() + "-" + (dateNow.getMonth() + 1) + "-" + dateNow.getFullYear();
    let fileName = tendiemdo + "_" + tenchucnang + "_" + strDate + ".xlsx";
    var param = {
      config: config,
      para: para,
      title: noidungbaocao + "_" + tendiemdo + "_" + strDate,
      header: "",
      filename: fileName,
      sheets: tenchucnang,
      columns: cols,
      data: data,
      mataikhoan: curUs.mataikhoan,
      danhmucid: danhmucid,
      loaibaocao: 5,
      tenbaocao: "Báo cáo trạng thái kết nối",
    };

    return this.apiService.Excute("api/SaveExcel", param);
  }


  getToaDoRepeater(danhmucid, imei) {
    var param = {
      "config": '{"namesql":"PKG_TRANGTHAIKETNOIRFMESH.P_LAYDS_DULIEU_BANDOSO"}',
      "para": '{"v_danhmucid":"' + danhmucid + '","v_imei ":"' + imei + '"}'
    };
    return this.apiService.Excute(this.APIURL, param);
  }
  getConfigSoNgayMatLienTuc(key) {
    return this.apiService.getConfigValue(key);
  }
}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/thong-ke-trang-thai/trang-thai-ket-noi-rfmesh/trangthaiketnoirfmesh.service.ts